class TouchTarget {
	element: Element;

	constructor(element: Element) {
		this.element = element;
	}

	onSwipe(direction: "left"|"right", action: Function) {
		let lastX: number = null;
		let lastTimestamp: number = null;

		let positionCheck: (x: number) => boolean;

		if (direction === "right")
			positionCheck = x => lastX && x - lastX > 100;
		else if (direction === "left")
			positionCheck = x => lastX && x - lastX < -100;
		else
			positionCheck = () => false;

		this.element.addEventListener("touchstart", (e: TouchEvent) => {
			lastX = e.touches[0].pageX;
			lastTimestamp = e.timeStamp;
		});

		this.element.addEventListener("touchend", (e: TouchEvent) => {
			let pageX = e.changedTouches[0].pageX;
			let timeStamp = e.timeStamp;

			//Lite naiv koll -- om X-positionen skiljer sig minst 100 pixlar åt höger, och det gått mindre
			//än 1 sekund så anser vi att det är en swipe-right.
			if (positionCheck(pageX) && timeStamp - lastTimestamp < 1000) {
				console.debug(`Swipe ${direction}!`);
				if (typeof(action) === "function")
					action();
			}

			lastX = null;
			lastTimestamp = null;
		});
	}
}

export default TouchTarget;